/* 带 Bearer 认证的 PDF 打开：api 拉 blob → 新标签预览（弹窗被拦时改为下载） */
export const openAuthedPdf = async (api, path, filename = "document.pdf") => {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  const w = window.open(url, "_blank", "noopener");
  if (!w) {
    const a = document.createElement("a");
    a.href = url; a.download = filename; a.click();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
